<template>
  <div id="contact">
    <headerbom :hdtitle="'联系我们'"></headerbom>
    <div class="map">
      <div id="container"></div>
      <p class="p">北京市丰台区汉威国际3区4号楼4M</p>
    </div>
    <ul>
      <li>
        <h1>公司地址</h1>
        <section v-for="(ele,index) in list1" :key="index">
          <h2>{{ele.name}}</h2>
          <p v-for="(val,ky) in ele.list" :key="ky">{{val}}</p>
        </section>
      </li>
      <li>
        <h1>广告合作</h1>
        <section v-for="(ele,index) in list2" :key="index">
          <h2>{{ele.name}}</h2>
          <p v-for="(val,ky) in ele.list" :key="ky">{{val}}</p>
        </section>
      </li>
      <li class="te">
        <h1>其他合作</h1>
        <section v-for="(ele,index) in list3" :key="index">
          <h2>{{ele.name}}</h2>
          <p v-for="(val,ky) in ele.list" :key="ky">{{val}}</p>
        </section>
      </li>
    </ul>
    <footerbom></footerbom>
  </div>
</template>

<script type="text/javascript">
export default {
  data() {
    return {
      list1: [
        {
          name: "北京总部",
          list: [
            "电话：010-56208704",
            "地址：北京市丰台区汉威国际3区4号楼4M",
            "邮编：100071",
          ],
        },
        {
          name: "上海公司",
          list: [
            "电话：18510100317",
            "地址：上海市静安区共和新路1878号大宁国际广场1号楼7楼727",
            "邮编：200070",
          ],
        },
        {
          name: "广州公司",
          list: [
            "电话：13247693560",
            "地址：广州市天河区车陂路113号东宏国际广场8楼811单元",
            "邮编：510000",
          ],
        },
      ],
      list2: [
        {
          name: "广告投放合作 (北京)",
          list: [
            "联系人：范女士",
            "邮箱：fanchunna@adjuz.net",
            "QQ：1161429499",
            "电话：18010063003",
          ],
        },
        {
          name: "广告投放合作 (上海)",
          list: [
            "联系人：吕先生",
            "邮箱：lvliang@adjuz.net",
            "QQ：2729286092",
            "电话：18510100317",
          ],
        },
        {
          name: "广告投放合作 (广州)",
          list: [
            "联系人：范女士",
            "邮箱：fanchunna@adjuz.net",
            "QQ：1161429499",
            "电话：18010063003",
          ],
        },
      ],
      list3: [
        {
          name: "开发者合作 (北京)",
          list: [
            "联系人：刘女士",
            "邮箱：liuwei@adjuz.net",
            "QQ：271966473",
            "电话：13552016263",
          ],
        },
        {
          name: "渠道合作 (北京)",
          list: [
            "联系人：刘女士",
            "邮箱：liuwei@adjuz.net",
            "QQ：271966473",
            "电话：13552016263",
          ],
        },
      ],
    };
  },
  computed: {},
  components: {},
  created() {},
  destroyed() {},
  mounted() {
    var map = new AMap.Map("container", {
      zoom: 15, //级别
      center: [116.29682, 39.82507], //中心点坐标
      viewMode: "3D", //使用3D视图
    });
    var marker = new AMap.Marker({
      position: new AMap.LngLat(116.29682, 39.82507),
      offset: new AMap.Pixel(-20, 10),
      icon: new AMap.Icon({
        image: require("../img/contact1.png"),
        size: new AMap.Size(52, 52), //图标大小
        imageSize: new AMap.Size(50, 50),
      }), // 添加 Icon 图标 URL
      title: "北京",
    });

    map.add(marker);
  },
  methods: {},
};
</script>

<style lang="less" scoped>
#contact {
  box-sizing: border-box;
  padding-top: 1rem;
  #container {
    width: 100%;
    height: 3.6rem;
  }
  .map .p {
    text-align: center;
    height: 0.9rem;
    line-height: 0.9rem;
    font-size: 0.26rem;
    color: @p;
    border-bottom: 0.01rem solid @border;
  }
  ul {
    display: flex;
    flex-wrap: wrap;
    box-sizing: border-box;
    padding: 0 0.22rem;
    li {
      width: 50%;
      margin-top: 0.8rem;
      &.te {
        width: 100%;
        section {
          float: left;
          width: 50%;
          &:last-child {
            box-sizing: border-box;
            padding-left: 0.6rem;
          }
        }
      }
      &:first-child {
        box-sizing: border-box;
        padding-right: 0.3rem;
      }
      &:nth-child(2) {
        box-sizing: border-box;
        padding-left: 0.3rem;
      }
      &:nth-child(3) {
        box-sizing: border-box;
        padding-right: 0.3rem;
      }
      h1 {
        font-size: 0.36rem;
        color: @h1;
        margin-bottom: 0.7rem;
      }
      h2 {
        font-size: 0.3rem;
        color: @h1;
        margin-bottom: 0.4rem;
      }
      p {
        font-size: 0.24rem;
        color: @p;
        line-height: 0.4rem;
      }
      section {
        margin-bottom: 0.6rem;
        height: 2.4rem;
      }
    }
  }
}
</style>
<style lang="less">
.amap-logo {
  z-index: 10 !important;
}
.amap-copyright {
  z-index: 10 !important;
}
</style>



// WEBPACK FOOTER //
// src/page/contact/index.vue